/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {
  type AgentChatAction,
  type AgentChatState,
  agentChatReducer,
  initialAgentChatState,
} from '../reducer';

export const EMPTY_AGENT_SESSION_KEY = '__new_agent_conversation__';

export type AgentSessionStore = Record<string, AgentChatState>;

export interface AgentSessionStoreAction {
  conversationId: string | undefined;
  action: AgentChatAction;
}

export const agentSessionStoreReducer = (
  state: AgentSessionStore,
  { action, conversationId }: AgentSessionStoreAction,
): AgentSessionStore => {
  const key = agentSessionKey(conversationId);
  return {
    ...state,
    [key]: agentChatReducer(state[key] ?? initialAgentChatState, action),
  };
};

export const agentSessionKey = (conversationId: string | undefined) =>
  conversationId ?? EMPTY_AGENT_SESSION_KEY;

export const agentSessionState = (
  state: AgentSessionStore,
  conversationId: string | undefined,
): AgentChatState => state[agentSessionKey(conversationId)] ?? initialAgentChatState;
